import React, { useState } from 'react'
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { ITypeForTopTen } from '../../../types';
import { State } from '../../../Reducers/types';
import { fetchDataBasedOnLevel, fetchDistrictDataBasedOnLevel, fetchTeacherDataBasedOnLevel, fetchDistrictTeacherDataBasedOnLevel } from '../../../Services/NewStats/StateOverViewAPIs';

export function useStatsMoreDetails() {

  const { filter } = useSelector((state: State) => state);

  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [data, setData] = useState<[{ district: string, Total_Usage: string }]>();


  const getClickData = async (district: string, block: string, type: ITypeForTopTen, week_no: number) => {

    try {
      setIsLoading(true);
      if (type?.for == "student") {
        if (district == "all") {
          const res = await fetchDataBasedOnLevel(type.type, week_no, filter.year);
          if (res?.data?.Is_Success) {
            let resData: any = res?.data?.response
            resData.sort((a: any, b: any) => +Object.entries(b)[1][1] - +Object.entries(a)[1][1])
            setData(resData);
          }
          else {
            toast.error(res?.data?.message)
          }
          setIsLoading(false)
        };

        if (district !== "all") {
          const res = await fetchDistrictDataBasedOnLevel(
            district,
            type?.type,
            week_no
          );
          if (res?.data?.Is_Success) {
            let resData: any = res?.data?.response
            resData.sort((a: any, b: any) => +Object.entries(b)[1][1] - +Object.entries(a)[1][1])
            setData(resData);
          }
          setIsLoading(false);
        };
      };

      if (type?.for == "teacher") {
        if (district == "all") {
          const res = await fetchTeacherDataBasedOnLevel(type.type, week_no, filter.year);
          if (res?.data?.Is_Success) {
            let resData: any = res?.data?.response
            resData.sort((a: any, b: any) => +Object.entries(b)[1][1] - +Object.entries(a)[1][1])
            setData(resData);
          }

          setIsLoading(false)
        }

        if (district !== "all") {
          const res = await fetchDistrictTeacherDataBasedOnLevel(
            district,
            type?.type,
            week_no
          );
          if (res?.data?.Is_Success) {
            let resData: any = res?.data?.response
            resData.sort((a: any, b: any) => +Object.entries(b)[1][1] - +Object.entries(a)[1][1])
            setData(resData);
          }
          setIsLoading(false);
        }
      };
    } catch {
      setIsLoading(false);
    };
    setIsLoading(false)
  };

  return {
    getClickData,
    data,
    isLoading,

  };

}